import { React, useState, useEffect } from "react";

const PopUpQueenraceResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };


    let total0Cards = [];
    let total1Cards = [];
    let total2Cards = [];
    let total3Cards = [];
    let queenRaceMarkets = [];
    let queenRaceWinner = "";

    if (marketType == 59) {
        total0Cards = resultData.c1
            ? resultData.c1.split(",")
            : [];
        total1Cards = resultData.c2
            ? resultData.c2.split(",")
            : [];
        total2Cards = resultData.c3
            ? resultData.c3.split(",")
            : [];
        total3Cards = resultData.c4
            ? resultData.c4.split(",")
            : [];
        queenRaceMarkets = [
            resultData.cat_rnr1,
            resultData.cat_rnr2,
            resultData.cat_rnr3,
            resultData.cat_rnr4,
        ].filter(Boolean);

        queenRaceWinner = resultData.resultTxt;
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="queen-race" style={{ display: marketType == 59 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div className="player-item">
                                        <b><span className="name" style={{ color: "#000" }}>Total 0</span></b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div className="BFBCardFanViewab" style={{ justifyContent: "flex-start", padding: "3px" }}>
                                                    {total0Cards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="player-item">
                                        <b><span className="name" style={{ color: "#000" }}>Total 1</span></b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div className="BFBCardFanViewab" style={{ justifyContent: "flex-start", padding: "3px" }}>
                                                    {total1Cards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="player-item">
                                        <b><span className="name" style={{ color: "#000" }}>Total 2</span></b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div className="BFBCardFanViewab" style={{ justifyContent: "flex-start", padding: "3px" }}>
                                                    {total2Cards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="player-item">
                                        <b><span className="name" style={{ color: "#000" }}>Total 3</span></b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div className="BFBCardFanViewab" style={{ justifyContent: "flex-start", padding: "3px" }}>
                                                    {total3Cards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        {queenRaceMarkets.map((market, index) => {
                                            const winner = market === queenRaceWinner;
                                            return (
                                                <div key={index} style={{ textAlign: "center", marginBottom: "18px" }}>
                                                    <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                                        {market}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "600",
                                                            marginTop: "4px",
                                                            color: "#000",
                                                            textTransform: "uppercase"
                                                        }}
                                                    >
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpQueenraceResults;

